import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://usaebookpoint.shop/cart/54943862129012:1';
type PurchaseButtonProps = {
  className?: string;
  label?: string;
};
export function PurchaseButton({
  className = '',
  label = 'Quiero mi kit RRHH ahora'
}: PurchaseButtonProps) {
  return <a className={`purchase-button ${className}`} href={CHECKOUT_URL} target="_blank" rel="noreferrer" aria-label={`${label}. Abre la página de pago`} data-id="element-11">
      <span data-id="element-12">{label}</span>
      <ArrowUpRightIcon size={19} aria-hidden="true" data-id="element-13" />
    </a>;
}